import { KeyInfo } from '../../components/common/types'
import {
  BaseActionType,
  CREATE_KEY_SUCCESS,
  DELETE_KEY_SUCCESS,
  LOAD_KEYS_SUCCESS,
  LOAD_MORE_KEYS_SUCCESS,
  UPDATE_KEY_SUCCESS,
  UPLOAD_KEYS_SUCCESS,
} from '../actions/actionTypes'

import { Keys, KeysReducerState } from './initialState'

const initialStateLocalAccessKeys: Keys = { keys: [], continuationToken: '' }

export function keyReducer(
  state = initialStateLocalAccessKeys,
  action: BaseActionType,
): KeysReducerState {
  switch (action.type) {
    case CREATE_KEY_SUCCESS: {
      return { ...state, keys: [action.payload as KeyInfo, ...state.keys] }
    }
    case UPDATE_KEY_SUCCESS: {
      const keys: KeyInfo[] = state.keys.map((key: KeyInfo) =>
        key.keyId === (action.payload as KeyInfo).keyId
          ? (action.payload as KeyInfo)
          : key,
      )
      return { ...state, keys }
    }
    case LOAD_KEYS_SUCCESS:
      return action.payload as KeysReducerState
    case LOAD_MORE_KEYS_SUCCESS:
      return {
        continuationToken: (action.payload as KeysReducerState)
          .continuationToken,
        keys: [...state.keys, ...(action.payload as KeysReducerState).keys],
      }
    case DELETE_KEY_SUCCESS: {
      const keys = state.keys.filter(
        (key: KeyInfo) => key.keyId !== (action.payload as KeyInfo).keyId,
      )
      return { ...state, keys }
    }
    case UPLOAD_KEYS_SUCCESS: {
      return {
        ...state,
        keys: [action.payload as KeyInfo, ...state.keys],
      }
    }
    default:
      return state
  }
}
